// This file is imported in all theme.liquid pages (most of Shopify pages uses theme.liquid).
import {renderStructuredElements} from "@/utils/render-helpers.jsx";
import AnnouncementBar from "@/components/AnnouncementBar";

document.addEventListener("DOMContentLoaded", () => {
  renderStructuredElements("announcement-bar", AnnouncementBar);
});
